import {useEffect} from 'react';
import {withTranslation} from "react-i18next";
import {connect} from 'react-redux';
import {useRecoilState} from "recoil";
import {setAppError} from '../../actions/datas';
import {logOut} from '../../actions/user';
import {
    disableUserMercureHandler,
    importProgressHandler,
    loginMercureHandler,
    logoutUserWithMessage
} from "../../utils/mercureHandler";
import {importProgression} from "../Admin/atoms/importAdmin";
import {useAppVersion} from "../../v4/contexts/AppVersionContext";
import isNewerVersion from "../../v4/utils/isNewerVersion";
import {getLSItem} from "../../v4/services/localStorage.service";

let currentEventSource = null;

const MercureComponent = ({children, user, logOut, t, setAppError}) => {
    const [, setImportProgress] = useRecoilState(importProgression)
    const {notifyUpdateAvailable} = useAppVersion()

    useEffect(() => {
        const {id} = getLSItem('user');
        if (id && !currentEventSource) {
            setEventSource(id, logOut, setImportProgress, setAppError, t, notifyUpdateAvailable);

        }

        return () => {
            if (currentEventSource instanceof EventSource) {
                currentEventSource.close();
            }
            currentEventSource = null;
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.user, logOut, setAppError, t, setImportProgress, notifyUpdateAvailable]);


    return (
        children
    );
};


const mapStateToProps = ({user}) => ({
    user
});

const mapDispatchToProps = dispatch => {
    return {
        logOut: () => dispatch(logOut()),
        setAppError: (errorMessage) => dispatch(setAppError(errorMessage))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(MercureComponent));

function setEventSource(userId, logOut, setImportProgress, setAppError, t, notifyUpdateAvailable) {
    currentEventSource = new EventSource(`${process.env.REACT_APP_MERCURE_HUB_URL}?topic=${process.env.REACT_APP_MERCURE_ENV_PREFIX}${encodeURIComponent(userId)}&topic=${process.env.REACT_APP_MERCURE_ENV_PREFIX}broadcast`);

    currentEventSource.onmessage = (message) => {
        const parsedMessage = JSON.parse(message.data);
        if (parsedMessage && parsedMessage.type) {
            switch (parsedMessage.type) {
                case 'login':
                    loginMercureHandler(parsedMessage, logOut, t, setAppError)
                    break;
                case 'disable':
                    disableUserMercureHandler(logOut, t, setAppError)
                    break;
                case 'rolesChanged':
                    logoutUserWithMessage(logOut, t, setAppError)
                    break;
                case 'import-progress' :
                    importProgressHandler(parsedMessage, setImportProgress);
                    break;
                case 'new-version-available':
                    if (isNewerVersion(parsedMessage.version, process.env.REACT_APP_VERSION)) {
                        notifyUpdateAvailable();
                    }
                    break;
                default:
                    break;
            }

        }
    };

    currentEventSource.onerror = () => setTimeout(() => {
        currentEventSource && currentEventSource.close();
        currentEventSource = null;
    }, 15000);
}
